import React from 'react';
import Select from "../../../common/components/select/Select";
import {useCustomerList} from "../../../hooks/useCustomerManagerHook";
import {BuOption} from "../../../types/Customer";
import {SingleValue} from "react-select";
import {useIntl} from "react-intl";


interface CustomerSelectProps {
  defaultValue: string;
  label?: string;
  placeholder?: string;
  onChange: (value: BuOption) => void;
  error?: string;
  touched?: boolean;
  name?: string;
  disabled?: boolean;
  value?: string;
  currentCustomerId?: string;
}


const CustomerSelector = ({
                            defaultValue,
                            label,
                            placeholder,
                            error,
                            touched,
                            name,
                            disabled = false,
                            onChange,
value,
currentCustomerId
                          }: CustomerSelectProps): JSX.Element => {
  const intl = useIntl();

  const {
    data: options = [],
    isLoading
  } = useCustomerList();

  const selectedOption = options.find(option =>
    option.id.toString() === value?.toString() || (value === "" && option.id.toString() === defaultValue.toString())
  );

  const handleSelectOption = (option: SingleValue<BuOption>) => {
    onChange(option as BuOption);
  }

  return (
    <Select<BuOption>
      label={label}
      isDisabled={disabled}
      isLoading={isLoading}
      isSearchable={true}
      name={name}
      value={selectedOption}
      onChange={handleSelectOption}
      getOptionValue={(customer: BuOption) => customer.id.toString()}
      getOptionLabel={(customer: BuOption) => {
        const label = `${customer.id.toString()} - ${customer.name}`;

        return customer.id.toString() === currentCustomerId
          ? `${label} ${intl.formatMessage({id: 'CUSTOMER_SCOPE.CURRENT'})}`
          : label;
      }}
      options={options}
      placeholder={placeholder}
      touched={touched}
      error={error}
    />
  );
};

export default CustomerSelector;